var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2835 10.4675C54.0974 10.4675 40.6953 7.0303 35.9181 0.662092C35.2827 -0.111735 34.1404 -0.223297 33.3664 0.412307C33.275 0.487132 33.1913 0.57085 33.1165 0.662229C28.3389 7.02976 14.9369 10.4675 4.75136 10.4675C3.78394 10.4675 3 11.2513 3 12.2185V34.9808C3 54.2344 19.7197 65.8417 34.0367 69.9315C34.3508 70.0228 34.684 70.0228 34.998 69.9315C49.315 65.8417 66.0347 54.2344 66.0347 34.9808V12.2185C66.0347 11.2513 65.2507 10.4674 64.2835 10.4674V10.4675ZM62.5324 34.9806C62.5324 52.0732 47.5535 62.5513 34.5174 66.4264C21.4809 62.5514 6.50163 52.0733 6.50163 34.9808V13.9388C16.6228 13.5966 28.591 10.334 34.5173 4.37332C40.4445 10.334 52.412 13.5966 62.5328 13.9384V34.9808L62.5324 34.9806Z",
    fill: "#D96122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5136 27.9771V31.4789H25.7625C24.7954 31.4789 24.0114 32.2628 24.0114 33.2301V47.2373C24.0114 48.2045 24.7954 48.9884 25.7625 48.9884H43.2721C44.2394 48.9884 45.0235 48.2045 45.0235 47.2373V33.2301C45.0235 32.2628 44.2394 31.4789 43.2721 31.4789H41.521V27.9771C41.521 24.1089 38.3855 20.9734 34.5173 20.9734C30.6491 20.9734 27.5136 24.1089 27.5136 27.9771ZM41.521 45.4866H27.5136V34.9808H41.5209L41.521 45.4866ZM38.0192 27.9771V31.4789H31.0155V27.9771C31.0155 26.0432 32.583 24.4753 34.5173 24.4753C36.4512 24.4753 38.0192 26.0432 38.0192 27.9771Z",
    fill: "#D96122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.31f50181dbb7c6787dfe56ecaeae1637.svg";
export { ForwardRef as ReactComponent };